import { PermissionsTypes } from './actionTypes';

export const getPermissions = (data: any) => ({
  type: PermissionsTypes.GET_PERMISSIONS,
  payload: data,
});

export const getPermissionsSuccess = (permissions: any) => {
  return {
    type: PermissionsTypes.GET_PERMISSIONS_SUCCESS,
    payload: permissions,
  };
};

export const getPermissionsFail = (error: any) => ({
  type: PermissionsTypes.GET_PERMISSIONS_FAIL,
  payload: error,
});

export const getPermissionsDetail = (permissionId: number) => ({
  type: PermissionsTypes.GET_PERMISSIONS_DETAIL,
  permissionId,
});

export const getPermissionsDetailSuccess = (permissions: any) => ({
  type: PermissionsTypes.GET_PERMISSIONS_DETAIL_SUCCESS,
  payload: permissions,
});

export const getPermissionsDetailFail = (error: any) => ({
  type: PermissionsTypes.GET_PERMISSIONS_DETAIL_FAIL,
  payload: error,
});

export const addPermissions = (permissionsAdd: any) => {
  return {
    type: PermissionsTypes.ADD_PERMISSIONS,
    payload: { permissionsAdd },
  };
};

export const addPermissionsSuccess = (permissionsAdd: any) => {
  return {
    type: PermissionsTypes.ADD_PERMISSIONS_SUCCESS,
    payload: permissionsAdd,
  };
};

export const addPermissionsFail = (error: any) => {
  return {
    type: PermissionsTypes.ADD_PERMISSIONS_FAIL,
    payload: error,
  };
};

export const deletePermissions = (data: any) => {
  return {
    type: PermissionsTypes.DELETE_PERMISSIONS,
    payload: data,
  };
};

export const deletePermissionsSuccess = (payload: any) => {
  return {
    type: PermissionsTypes.DELETE_PERMISSIONS_SUCCESS,
    payload,
  };
};

export const deletePermissionsFail = (error: any) => {
  return {
    type: PermissionsTypes.DELETE_PERMISSIONS_FAIL,
    payload: error,
  };
};

export const updatePermissions = (permissions: any) => {
  return {
    type: PermissionsTypes.UPDATE_PERMISSIONS,
    payload: { permissions },
  };
};

export const updatePermissionsSuccess = (permissions: any) => {
  return {
    type: PermissionsTypes.UPDATE_PERMISSIONS_SUCCESS,
    payload: permissions,
  };
};

export const updatePermissionsFail = (error: any) => {
  return {
    type: PermissionsTypes.UPDATE_PERMISSIONS_FAIL,
    payload: error,
  };
};
